export const LS_PHONE_NUMBER = '646-88-SMART'
export const LS_PHONE_NUMBER_MASK = '(646) 887 6278'
